import styled from "styled-components";

export const SectionHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;
